import { useLocation } from 'react-router-dom';

export const useActiveSection = () => {
  const location = useLocation();
  return location.hash.substring(1);
};
